import { SvgIcon } from "@mui/material";

export const ValidationIcon = () => {
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      sx={{ width: "20px", height: "20px", fill: "none" }}
    >
      <path
        d="m16.5 9.5-4.2 4.2-1.6-2.4-3.2 3.2"
        stroke="#485467"
        strokeWidth={1.8}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5 9.5h2v2"
        stroke="#485467"
        strokeWidth={1.8}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 22h6c5 0 7-2 7-7V9c0-5-2-7-7-7H9C4 2 2 4 2 9v6c0 5 2 7 7 7"
        stroke="#485467"
        strokeWidth={1.8}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};
